import cn from 'classnames';
import { cssX } from "@datassential/platform-ui-lib";
import { IconPpt, IconXls } from '@icons';

export type ExportFileFormat = 'ppt' | 'xls';

export interface ExportMenuOption {
    title: string;
    fileFormat?: ExportFileFormat;
    onClick: () => void;
}

interface ExportMenuItemProps {
    option: ExportMenuOption;
    onSelect: () => void;
}

const renderExportIcon = (fileFormat: ExportFileFormat = 'xls', className?: string) => {
    const IconComponent = fileFormat === 'ppt' ? IconPpt : IconXls;
    return <IconComponent className={className} />;
};

const ExportMenuItem = ({ option, onSelect }: ExportMenuItemProps) => {
    const handleClick = () => {
        option.onClick();
        onSelect();
    };

    return (
        <div className={cssX("Dropdown__row")}>
            <button
                type="button"
                className={cn(
                    cssX('Dropdown__item'),
                    cssX('SelectComponent__item')
                )}
                style={{ display: 'flex', alignItems: 'center' }}
                onClick={handleClick}
            >
                {renderExportIcon(option.fileFormat, cssX("Dropdown__icon"))}
                <span style={{ marginLeft: '8px' }}>{option.title}</span>
            </button>
        </div>
    );
};

export default ExportMenuItem;